import { getPrice } from '@dustin-web/microsite-data/src/utils'
import type { VariantValue } from '../product-variant-group/product-variant-group.types'

export type PriceDifference = {
  sign: '+' | '-' | ''
  amount: number
}

export function getPriceDifference(
  productPrice: NonNullable<VariantValue['product']>['price'],
  showPrice: boolean,
  showPricesInclVat: boolean,
  selectedPrice: number | null
): PriceDifference | null {
  if (!showPrice || selectedPrice == null) {
    return null
  }

  const variantPrice = productPrice ? getPrice(productPrice, showPricesInclVat) : null

  if (variantPrice == null) {
    return null
  }

  const diff = variantPrice - selectedPrice

  if (diff === 0) {
    return null
  }

  return { sign: diff > 0 ? '+' : '-', amount: Math.abs(diff) }
}
